var _mask, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 352,
    viewBox: "0 0 720 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3763_57849",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.898 33C258.678 33 253.635 38.0424 253.635 44.2625V200.804H466.72V44.2625C466.72 38.0424 461.677 33 455.457 33H264.898ZM282.608 133.658C279.109 133.658 276.273 136.495 276.273 139.993C276.273 143.492 279.109 146.329 282.608 146.329H437.467C440.965 146.329 443.802 143.492 443.802 139.993C443.802 136.495 440.965 133.658 437.467 133.658H282.608ZM276.273 163.926C276.273 160.427 279.109 157.591 282.608 157.591H361.445C364.944 157.591 367.78 160.427 367.78 163.926C367.78 167.425 364.944 170.261 361.445 170.261H282.608C279.109 170.261 276.273 167.425 276.273 163.926ZM378.643 84.9725L368.32 95.2956L378.643 105.619C379.762 106.738 380.45 108.236 380.45 109.936C380.45 111.636 379.762 113.134 378.643 114.253C377.524 115.372 376.026 116.061 374.326 116.061C372.625 116.061 371.127 115.372 370.008 114.253L359.685 103.93L349.362 114.253C348.243 115.372 346.745 116.061 345.045 116.061C343.344 116.061 341.846 115.372 340.727 114.253C339.608 113.134 338.92 111.636 338.92 109.936C338.92 108.236 339.608 106.738 340.727 105.619L351.051 95.2956L340.727 84.9725C339.608 83.8535 338.92 82.3555 338.92 80.6552C338.92 78.9548 339.608 77.4568 340.727 76.3378C341.846 75.2188 343.344 74.5304 345.045 74.5304C346.745 74.5304 348.243 75.2188 349.362 76.3378L359.685 86.6609L370.008 76.3378C371.127 75.2188 372.625 74.5304 374.326 74.5304C376.026 74.5304 377.524 75.2188 378.643 76.3378C379.762 77.4568 380.45 78.9548 380.45 80.6552C380.45 82.3556 379.762 83.8535 378.643 84.9725Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.898 33C258.678 33 253.635 38.0424 253.635 44.2625V200.804H466.72V44.2625C466.72 38.0424 461.677 33 455.457 33H264.898ZM282.608 133.658C279.109 133.658 276.273 136.495 276.273 139.993C276.273 143.492 279.109 146.329 282.608 146.329H437.467C440.965 146.329 443.802 143.492 443.802 139.993C443.802 136.495 440.965 133.658 437.467 133.658H282.608ZM276.273 163.926C276.273 160.427 279.109 157.591 282.608 157.591H361.445C364.944 157.591 367.78 160.427 367.78 163.926C367.78 167.425 364.944 170.261 361.445 170.261H282.608C279.109 170.261 276.273 167.425 276.273 163.926ZM378.643 84.9725L368.32 95.2956L378.643 105.619C379.762 106.738 380.45 108.236 380.45 109.936C380.45 111.636 379.762 113.134 378.643 114.253C377.524 115.372 376.026 116.061 374.326 116.061C372.625 116.061 371.127 115.372 370.008 114.253L359.685 103.93L349.362 114.253C348.243 115.372 346.745 116.061 345.045 116.061C343.344 116.061 341.846 115.372 340.727 114.253C339.608 113.134 338.92 111.636 338.92 109.936C338.92 108.236 339.608 106.738 340.727 105.619L351.051 95.2956L340.727 84.9725C339.608 83.8535 338.92 82.3555 338.92 80.6552C338.92 78.9548 339.608 77.4568 340.727 76.3378C341.846 75.2188 343.344 74.5304 345.045 74.5304C346.745 74.5304 348.243 75.2188 349.362 76.3378L359.685 86.6609L370.008 76.3378C371.127 75.2188 372.625 74.5304 374.326 74.5304C376.026 74.5304 377.524 75.2188 378.643 76.3378C379.762 77.4568 380.45 78.9548 380.45 80.6552C380.45 82.3556 379.762 83.8535 378.643 84.9725Z",
    fill: "url(#paint0_linear_3763_57849)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.635 200.804H252.932V201.508H253.635V200.804ZM466.72 200.804V201.508H467.424V200.804H466.72ZM368.32 95.2956L367.822 94.7978L367.324 95.2956L367.822 95.7933L368.32 95.2956ZM378.643 84.9725L379.141 85.4703L378.643 84.9725ZM378.643 105.619L379.141 105.121L378.643 105.619ZM378.643 114.253L379.141 114.751L378.643 114.253ZM370.008 114.253L369.51 114.751L370.008 114.253ZM359.685 103.93L360.183 103.433L359.685 102.935L359.187 103.433L359.685 103.93ZM349.362 114.253L348.864 113.756L349.362 114.253ZM340.727 114.253L340.23 114.751L340.727 114.253ZM340.727 105.619L340.23 105.121L340.727 105.619ZM351.051 95.2956L351.548 95.7933L352.046 95.2956L351.548 94.7978L351.051 95.2956ZM340.727 84.9725L340.23 85.4703L340.727 84.9725ZM340.727 76.3378L340.23 75.8401L340.727 76.3378ZM349.362 76.3378L348.864 76.8356L349.362 76.3378ZM359.685 86.6609L359.187 87.1586L359.685 87.6563L360.183 87.1586L359.685 86.6609ZM370.008 76.3378L369.51 75.8401L370.008 76.3378ZM378.643 76.3378L379.141 75.8401L378.643 76.3378ZM254.339 44.2625C254.339 38.4311 259.067 33.7039 264.898 33.7039V32.2961C258.289 32.2961 252.932 37.6536 252.932 44.2625H254.339ZM254.339 200.804V44.2625H252.932V200.804H254.339ZM466.72 200.1H253.635V201.508H466.72V200.1ZM466.016 44.2625V200.804H467.424V44.2625H466.016ZM455.457 33.7039C461.288 33.7039 466.016 38.4311 466.016 44.2625H467.424C467.424 37.6536 462.066 32.2961 455.457 32.2961V33.7039ZM264.898 33.7039H455.457V32.2961H264.898V33.7039ZM276.977 139.993C276.977 136.883 279.498 134.362 282.608 134.362V132.954C278.72 132.954 275.569 136.106 275.569 139.993H276.977ZM282.608 145.625C279.498 145.625 276.977 143.103 276.977 139.993H275.569C275.569 143.881 278.72 147.032 282.608 147.032V145.625ZM437.467 145.625H282.608V147.032H437.467V145.625ZM443.098 139.993C443.098 143.103 440.577 145.625 437.467 145.625V147.032C441.354 147.032 444.506 143.881 444.506 139.993H443.098ZM437.467 134.362C440.577 134.362 443.098 136.883 443.098 139.993H444.506C444.506 136.106 441.354 132.954 437.467 132.954V134.362ZM282.608 134.362H437.467V132.954H282.608V134.362ZM282.608 156.887C278.72 156.887 275.569 160.038 275.569 163.926H276.977C276.977 160.816 279.498 158.295 282.608 158.295V156.887ZM361.445 156.887H282.608V158.295H361.445V156.887ZM368.484 163.926C368.484 160.038 365.333 156.887 361.445 156.887V158.295C364.555 158.295 367.076 160.816 367.076 163.926H368.484ZM361.445 170.965C365.333 170.965 368.484 167.814 368.484 163.926H367.076C367.076 167.036 364.555 169.557 361.445 169.557V170.965ZM282.608 170.965H361.445V169.557H282.608V170.965ZM275.569 163.926C275.569 167.814 278.72 170.965 282.608 170.965V169.557C279.498 169.557 276.977 167.036 276.977 163.926H275.569ZM368.818 95.7933L379.141 85.4703L378.145 84.4748L367.822 94.7978L368.818 95.7933ZM379.141 105.121L368.818 94.7978L367.822 95.7933L378.145 106.116L379.141 105.121ZM381.154 109.936C381.154 108.036 380.382 106.363 379.141 105.121L378.145 106.116C379.141 107.113 379.746 108.435 379.746 109.936H381.154ZM379.141 114.751C380.382 113.509 381.154 111.836 381.154 109.936H379.746C379.746 111.437 379.141 112.759 378.145 113.756L379.141 114.751ZM374.326 116.765C376.225 116.765 377.899 115.993 379.141 114.751L378.145 113.756C377.149 114.752 375.827 115.357 374.326 115.357V116.765ZM369.51 114.751C370.752 115.993 372.426 116.765 374.326 116.765V115.357C372.825 115.357 371.502 114.752 370.506 113.756L369.51 114.751ZM359.187 104.428L369.51 114.751L370.506 113.756L360.183 103.433L359.187 104.428ZM349.86 114.751L360.183 104.428L359.187 103.433L348.864 113.756L349.86 114.751ZM345.045 116.765C346.945 116.765 348.618 115.993 349.86 114.751L348.864 113.756C347.868 114.752 346.546 115.357 345.045 115.357V116.765ZM340.23 114.751C341.471 115.993 343.145 116.765 345.045 116.765V115.357C343.544 115.357 342.221 114.752 341.225 113.756L340.23 114.751ZM338.216 109.936C338.216 111.836 338.988 113.509 340.23 114.751L341.225 113.756C340.229 112.759 339.624 111.437 339.624 109.936H338.216ZM340.23 105.121C338.988 106.363 338.216 108.036 338.216 109.936H339.624C339.624 108.435 340.229 107.113 341.225 106.116L340.23 105.121ZM350.553 94.7978L340.23 105.121L341.225 106.116L351.548 95.7933L350.553 94.7978ZM340.23 85.4703L350.553 95.7933L351.548 94.7978L341.225 84.4748L340.23 85.4703ZM338.216 80.6552C338.216 82.5549 338.988 84.2285 340.23 85.4703L341.225 84.4748C340.229 83.4785 339.624 82.1562 339.624 80.6552H338.216ZM340.23 75.8401C338.988 77.0818 338.216 78.7554 338.216 80.6552H339.624C339.624 79.1542 340.229 77.8318 341.225 76.8356L340.23 75.8401ZM345.045 73.8265C343.145 73.8265 341.471 74.5984 340.23 75.8401L341.225 76.8356C342.221 75.8393 343.544 75.2343 345.045 75.2343V73.8265ZM349.86 75.8401C348.618 74.5984 346.945 73.8265 345.045 73.8265V75.2343C346.546 75.2343 347.868 75.8393 348.864 76.8356L349.86 75.8401ZM360.183 86.1631L349.86 75.8401L348.864 76.8356L359.187 87.1586L360.183 86.1631ZM369.51 75.8401L359.187 86.1631L360.183 87.1586L370.506 76.8356L369.51 75.8401ZM374.326 73.8265C372.426 73.8265 370.752 74.5984 369.51 75.8401L370.506 76.8356C371.502 75.8393 372.825 75.2343 374.326 75.2343V73.8265ZM379.141 75.8401C377.899 74.5984 376.225 73.8265 374.326 73.8265V75.2343C375.827 75.2343 377.149 75.8393 378.145 76.8356L379.141 75.8401ZM381.154 80.6552C381.154 78.7554 380.382 77.0818 379.141 75.8401L378.145 76.8356C379.141 77.8318 379.746 79.1542 379.746 80.6552H381.154ZM379.141 85.4703C380.382 84.2285 381.154 82.555 381.154 80.6552H379.746C379.746 82.1562 379.141 83.4785 378.145 84.4748L379.141 85.4703Z",
    fill: "url(#paint1_linear_3763_57849)",
    mask: "url(#path-1-inside-1_3763_57849)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.011 47.0773C265.011 45.5223 266.271 44.2617 267.826 44.2617H421.981C423.536 44.2617 424.797 45.5223 424.797 47.0773C424.797 48.6324 423.536 49.8929 421.981 49.8929H267.826C266.271 49.8929 265.011 48.6324 265.011 47.0773Z",
    fill: "#D6D6E3",
    fillOpacity: 0.33
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 435.355,
    cy: 47.0773,
    r: 2.81561,
    fill: "#D6D6E3",
    fillOpacity: 0.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.802,
    cy: 47.0773,
    r: 2.81561,
    fill: "#D6D6E3",
    fillOpacity: 0.72
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.249,
    cy: 47.0773,
    r: 2.81561,
    fill: "#D6D6E3",
    fillOpacity: 0.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M227 312.369C227 309.23 286.712 306.738 360.39 306.738C434.067 306.738 493.779 309.28 493.779 312.369C493.779 315.509 434.067 318.001 360.39 318.001C286.712 318.001 227 315.459 227 312.369Z",
    fill: "#E6E6F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.823 217.241C267.67 227.864 266.642 241.028 263.262 252.06L249.261 247.696C252.241 238.031 253.104 226.056 253.21 216.428C253.264 211.554 253.123 207.273 252.964 204.187C252.884 202.644 252.799 201.399 252.732 200.527C252.698 200.091 252.668 199.748 252.645 199.507C252.644 199.491 252.642 199.475 252.641 199.459L267.185 198.096C267.361 199.832 267.964 207.441 267.823 217.241Z",
    fill: "url(#paint2_linear_3763_57849)",
    stroke: "url(#paint3_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M269.182 214.96V214.962C268.993 248.079 268.898 259.415 267.027 276.298L281.575 277.934C283.565 260.878 283.627 249.563 283.802 218.018C283.807 217.019 283.813 216 283.819 214.959C283.819 214.959 283.819 214.958 283.819 214.958L284.171 214.96C284.171 212.611 284.192 210.155 284.215 207.572C284.24 204.706 284.266 201.683 284.266 198.476L269.182 214.96ZM269.182 214.96C269.182 212.613 269.203 210.137 269.226 207.53C269.227 207.388 269.228 207.245 269.23 207.102C269.253 204.446 269.275 201.657 269.277 198.735L283.914 198.826L269.182 214.96Z",
    fill: "url(#paint4_linear_3763_57849)",
    stroke: "url(#paint5_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.715 286.914L288.349 290.005C285.987 278.513 285.332 256.455 285.284 236.814C285.239 218.038 285.75 201.515 285.844 198.648L300.484 199.102L300.469 199.624C300.454 200.155 300.433 200.918 300.407 201.883C300.356 203.815 300.288 206.562 300.22 209.904C300.085 216.589 299.951 225.658 299.957 235.362C299.969 254.544 300.527 276.26 302.715 286.914Z",
    fill: "url(#paint6_linear_3763_57849)",
    stroke: "url(#paint7_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.173 198.555C317.184 199.103 317.212 200.147 317.25 201.599C317.569 213.533 318.621 253.016 317.103 271.176L302.559 269.903C303.389 259.819 303.386 242.287 303.174 227.162C303.067 219.508 302.906 212.465 302.772 207.305C302.705 204.725 302.645 202.616 302.601 201.138C302.583 200.521 302.568 200.014 302.556 199.628C302.554 199.551 302.552 199.479 302.55 199.412C302.546 199.292 302.543 199.188 302.54 199.1L317.173 198.555Z",
    fill: "url(#paint8_linear_3763_57849)",
    stroke: "url(#paint9_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M337.958 285.03L323.868 288.848C320.756 276.769 319.559 254.986 319.146 235.771C318.791 219.247 319.015 204.67 319.089 199.863C319.097 199.337 319.104 198.928 319.107 198.646L333.741 199.009C333.74 199.034 333.74 199.061 333.739 199.088C333.687 201.774 333.395 216.788 333.711 234.011C334.053 252.639 335.106 273.925 337.958 285.03Z",
    fill: "url(#paint10_linear_3763_57849)",
    stroke: "url(#paint11_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M351.902 276.118L337.353 278.21C335.872 267.449 335.451 248.247 335.416 231.336C335.382 215.236 335.698 201.241 335.774 198.646L350.416 199.009C350.414 199.083 350.412 199.167 350.41 199.263C350.385 200.531 350.321 203.738 350.258 208.21C350.178 213.949 350.1 221.759 350.112 230.182C350.136 246.826 350.508 265.9 351.902 276.118Z",
    fill: "url(#paint12_linear_3763_57849)",
    stroke: "url(#paint13_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M366.173 266.098C365.521 275.257 364.543 283.359 363.102 288.848L349.012 285.03C351.201 276.573 352.179 259.722 352.555 242.694C352.931 225.633 352.704 208.34 352.468 199.007L367.1 198.552C367.106 198.919 367.117 199.499 367.132 200.27C367.238 205.635 367.526 220.239 367.299 236.512C367.162 246.335 366.837 256.755 366.173 266.098Z",
    fill: "url(#paint14_linear_3763_57849)",
    stroke: "url(#paint15_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M384.958 277.934L370.409 280.207C368.603 268.66 368.23 248.903 368.324 231.648C368.414 215.256 368.925 201.152 369.025 198.554L383.665 199.1C383.661 199.209 383.657 199.342 383.652 199.498L383.652 199.504C383.636 199.96 383.615 200.613 383.588 201.441C383.535 203.105 383.463 205.474 383.388 208.368C383.238 214.157 383.074 222.047 383.02 230.595C382.914 247.499 383.239 267.014 384.958 277.934Z",
    fill: "url(#paint16_linear_3763_57849)",
    stroke: "url(#paint17_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.618 263.677V198.827H400.255V263.677H385.618Z",
    fill: "url(#paint18_linear_3763_57849)",
    stroke: "url(#paint19_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M417.525 232.276C417.525 249.801 416.846 269.679 414.257 280.755L399.981 277.3C402.307 267.149 402.864 247.795 402.829 230.87C402.811 222.303 402.641 214.343 402.47 208.49C402.384 205.563 402.298 203.163 402.23 201.476C402.197 200.633 402.167 199.967 402.145 199.503C402.137 199.344 402.131 199.208 402.125 199.097L416.761 198.46C416.91 201.075 417.525 215.581 417.525 232.276Z",
    fill: "url(#paint20_linear_3763_57849)",
    stroke: "url(#paint21_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M427.066 291.762C424.529 286.478 422.718 278.579 421.441 269.533C420.139 260.314 419.395 249.938 418.99 239.993C418.204 220.674 418.698 203.005 418.858 198.65L433.496 199.195C433.171 208.769 433.018 226.421 433.854 243.609C434.277 252.309 434.954 260.897 435.99 268.26C436.998 275.413 438.349 281.448 440.157 285.307L427.066 291.762Z",
    fill: "url(#paint22_linear_3763_57849)",
    stroke: "url(#paint23_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M454.315 275.757L439.951 278.575C437.762 267.128 436.636 247.843 436.058 231.037C435.509 215.083 435.455 201.393 435.451 198.827H450.088C450.095 201.12 450.157 214.184 450.659 229.441C451.201 245.898 452.256 264.942 454.315 275.757Z",
    fill: "url(#paint24_linear_3763_57849)",
    stroke: "url(#paint25_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M457.069 255.211C454.617 246.194 453.355 232.515 452.709 220.823C452.106 209.94 452.038 200.81 452.031 198.827H466.668C466.678 200.634 466.752 209.118 467.275 219.169C467.85 230.229 468.97 243.227 471.16 251.302L457.069 255.211Z",
    fill: "url(#paint26_linear_3763_57849)",
    stroke: "url(#paint27_linear_3763_57849)",
    strokeWidth: 0.703903
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3763_57849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 198,
    width: 217,
    height: 41,
    fill: "url(#paint28_linear_3763_57849)",
    fillOpacity: 0.16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_3763_57849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.941 204.25C478.941 204.92 477.886 205.456 476.568 205.456H462.632C462.342 204.635 461.559 204.048 460.64 204.048C459.72 204.048 458.938 204.635 458.648 205.456H449.257C448.968 204.635 448.185 204.048 447.266 204.048C446.346 204.048 445.564 204.635 445.274 205.456H435.883C435.593 204.635 434.811 204.048 433.892 204.048C432.972 204.048 432.19 204.635 431.9 205.456H422.509C422.219 204.635 421.437 204.048 420.517 204.048C419.598 204.048 418.815 204.635 418.526 205.456H409.135C408.845 204.635 408.063 204.048 407.144 204.048C406.224 204.048 405.442 204.635 405.152 205.456H395.761C395.471 204.635 394.689 204.048 393.769 204.048C392.85 204.048 392.068 204.635 391.778 205.456H382.386C382.097 204.635 381.314 204.048 380.395 204.048C379.475 204.048 378.693 204.635 378.403 205.456H369.012C368.722 204.635 367.94 204.048 367.021 204.048C366.101 204.048 365.319 204.635 365.029 205.456H355.638C355.349 204.635 354.566 204.048 353.647 204.048C352.727 204.048 351.945 204.635 351.655 205.456H342.264C341.974 204.635 341.192 204.048 340.273 204.048C339.353 204.048 338.571 204.635 338.281 205.456H328.89C328.6 204.635 327.818 204.048 326.898 204.048C325.979 204.048 325.197 204.635 324.907 205.456H315.516C315.226 204.635 314.444 204.048 313.524 204.048C312.605 204.048 311.822 204.635 311.533 205.456H302.142C301.852 204.635 301.07 204.048 300.15 204.048C299.231 204.048 298.449 204.635 298.159 205.456H288.767C288.478 204.635 287.695 204.048 286.776 204.048C285.856 204.048 285.074 204.635 284.784 205.456H275.393C275.103 204.635 274.321 204.048 273.402 204.048C272.482 204.048 271.7 204.635 271.41 205.456H262.019C261.729 204.635 260.947 204.048 260.027 204.048C259.108 204.048 258.326 204.635 258.036 205.456H242.691C241.373 205.456 240.318 204.92 240.318 204.25V191.88C240.318 191.21 241.373 190.674 242.691 190.674H476.568C477.886 190.674 478.941 191.21 478.941 191.88V204.25Z",
    fill: "url(#paint29_linear_3763_57849)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3763_57849",
    x: 244.009,
    y: 190.009,
    width: 232.981,
    height: 56.9813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.99533,
    result: "effect1_foregroundBlur_3763_57849"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_3763_57849",
    x: 234.991,
    y: 188.898,
    width: 249.277,
    height: 25.4355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66355
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.517778 0 0 0 0 0.517778 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3763_57849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3763_57849",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.7757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.443925
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.659167 0 0 0 0 0.659167 0 0 0 0 0.7 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3763_57849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3763_57849",
    x1: 360.037,
    y1: 33,
    x2: 360.037,
    y2: 225.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3763_57849",
    x1: 360.037,
    y1: 33,
    x2: 360.037,
    y2: 225.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3763_57849",
    x1: 258.508,
    y1: 197.713,
    x2: 258.508,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3763_57849",
    x1: 258.508,
    y1: 197.713,
    x2: 258.508,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3763_57849",
    x1: 275.452,
    y1: 198.381,
    x2: 275.452,
    y2: 278.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3763_57849",
    x1: 275.452,
    y1: 198.381,
    x2: 275.452,
    y2: 278.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3763_57849",
    x1: 294.031,
    y1: 198.285,
    x2: 294.031,
    y2: 290.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3763_57849",
    x1: 294.031,
    y1: 198.285,
    x2: 294.031,
    y2: 290.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3763_57849",
    x1: 310.217,
    y1: 198.189,
    x2: 310.217,
    y2: 271.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3763_57849",
    x1: 310.217,
    y1: 198.189,
    x2: 310.217,
    y2: 271.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3763_57849",
    x1: 328.493,
    y1: 198.285,
    x2: 328.493,
    y2: 289.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3763_57849",
    x1: 328.493,
    y1: 198.285,
    x2: 328.493,
    y2: 289.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3763_57849",
    x1: 343.68,
    y1: 198.285,
    x2: 343.68,
    y2: 278.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3763_57849",
    x1: 343.68,
    y1: 198.285,
    x2: 343.68,
    y2: 278.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3763_57849",
    x1: 358.159,
    y1: 198.189,
    x2: 358.159,
    y2: 289.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3763_57849",
    x1: 358.159,
    y1: 198.189,
    x2: 358.159,
    y2: 289.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3763_57849",
    x1: 376.66,
    y1: 198.189,
    x2: 376.66,
    y2: 280.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3763_57849",
    x1: 376.66,
    y1: 198.189,
    x2: 376.66,
    y2: 280.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3763_57849",
    x1: 392.937,
    y1: 198.475,
    x2: 392.937,
    y2: 264.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3763_57849",
    x1: 392.937,
    y1: 198.475,
    x2: 392.937,
    y2: 264.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3763_57849",
    x1: 408.718,
    y1: 198.094,
    x2: 408.718,
    y2: 281.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3763_57849",
    x1: 408.718,
    y1: 198.094,
    x2: 408.718,
    y2: 281.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3763_57849",
    x1: 429.415,
    y1: 198.285,
    x2: 429.415,
    y2: 292.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3763_57849",
    x1: 429.415,
    y1: 198.285,
    x2: 429.415,
    y2: 292.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3763_57849",
    x1: 444.913,
    y1: 198.475,
    x2: 444.913,
    y2: 278.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3763_57849",
    x1: 444.913,
    y1: 198.475,
    x2: 444.913,
    y2: 278.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3763_57849",
    x1: 461.635,
    y1: 198.475,
    x2: 461.635,
    y2: 255.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3763_57849",
    x1: 461.635,
    y1: 198.475,
    x2: 461.635,
    y2: 255.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3763_57849",
    x1: 360.858,
    y1: 205.593,
    x2: 361.375,
    y2: 240.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528997,
    stopColor: "#505050",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3763_57849",
    x1: 359.731,
    y1: 194.616,
    x2: 359.707,
    y2: 203.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6DD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/Deleted.7c33a74036f0f3be8c3afc379f009c64.svg";
export { ForwardRef as ReactComponent };